import React from "react";
import {Navigate} from "react-router-dom";
import FetchData from '../components/FetchData';

function LogoutPage() {
	const options = {
		method: "GET",
		headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
	};

	FetchData("userapi/user/logout?refresh_token=" + localStorage.getItem("refresh"), options);

	localStorage.removeItem("token");
	localStorage.removeItem("refresh");
	localStorage.removeItem("time");
	localStorage.setItem("isAdmin", false);
	return <Navigate to="/login" replace={true} />
}

export default LogoutPage;